import { useDimensions } from "@repo/core/hooks/useDimensions";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNewTransactionStore } from "@repo/core/stores/newTransaction";
import { cardFormSchema, cpfFormSchema } from "@repo/core/helpers/zod.schemas";
import { useIdentityTypeInput } from "@repo/core/hooks/useIdentityTypeInput";
import { IdentityInputTypeEnum } from "@repo/core/components/forms/IdentityTypeInput/types";
import { CardConsultDataResponseDTO } from "@repo/core/services/entities/Card";
import { useNewTransactionFlow } from "@repo/core/hooks/useNewTransactionFlow";

export const NewTransactionIdentityController = () => {
  // Hooks
  const { isMobile } = useDimensions();
  const { navigateToNext, navigateBack, currentRouteConfig } =
    useNewTransactionFlow();

  // Store
  const { setSelectedProduct } = useNewTransactionStore();

  // Identity Input
  const {
    selectedIdentityInputType,
    handleOnChangeIdentityType,
    handleOnSelectProduct,
    productInfo
  } = useIdentityTypeInput({
    onSelectProduct: (product?: CardConsultDataResponseDTO) => {
      if (!product) return;
      setSelectedProduct(product);
    }
  });

  // Form
  const formSchema =
    selectedIdentityInputType === IdentityInputTypeEnum.CPF
      ? cpfFormSchema
      : cardFormSchema;

  const {
    control,
    formState: { isValid, isSubmitting },
    handleSubmit
  } = useForm({
    resolver: zodResolver(formSchema)
  });

  const handleSubmitIdentity = handleSubmit(() => {
    navigateToNext();
  });

  return {
    // Layout
    isMobile,

    // Form
    control,
    isValid,
    isSubmitting,

    // Data
    productInfo,
    selectedIdentityInputType,
    title: currentRouteConfig.title,
    showConfirmStoreModal: currentRouteConfig.showConfirmStoreModal,
    // Handlers
    handleBack: navigateBack,
    handleOnSubmitForm: handleSubmitIdentity,
    handleOnChangeIdentityType,
    handleOnSelectProduct
  };
};
